import * as React from 'react';
import * as _ from 'lodash';
import * as presetPages from '../../../../constants/pricingPresets';
import AlgorithmPresets from '../../../../components/StoneSetup/AssignPricing/PricingPresets/algorithmPresets';
import NewPreset from '../../../../components/StoneSetup/AssignPricing/PricingPresets/newPreset';
import EditPreset from '../../../../components/StoneSetup/AssignPricing/PricingPresets/editPreset';
import Footer from '../../../../components/StoneSetup/AssignPricing/PricingPresets/footer';
export default function () {
    return React.createElement('div', { 'className': 'ui-popup ' + (this.state.page === presetPages.PRICING_PRESET_EDIT ? 'ui-popup--algorithm' : 'ui-popup--large') }, React.createElement('div', { 'className': 'ui-popup-header' }, React.createElement('span', { 'className': 'ui-popup-header__text' }, this.props.title)), this.state.page === presetPages.PRICING_PRESET_LIST ? React.createElement(AlgorithmPresets, {
        'toPage': this.toPage,
        'key': '821'
    }) : null, this.state.page === presetPages.PRICING_PRESET_NEW ? React.createElement(NewPreset, {
        'toPage': this.toPage,
        'key': '926'
    }) : null, this.state.page === presetPages.PRICING_PRESET_EDIT ? React.createElement(EditPreset, {
        'toPage': this.toPage,
        'key': '1023'
    }) : null, React.createElement(Footer, { 'toPage': this.toPage }));
}